import { learningObjectivesIntro, initialPost, activitiesListIntro } from './AL00000Sprint00'
import { oreillyPlaylistSE, externalLink } from '../DataAndAPIs/Links'
import { estimated } from './AL00000Sprint00'
import { getModuleDescription } from '../DataAndAPIs/ClassSections'
import { softwareEngineeringSprint6Link } from '../Activities/ClassProduct'

export const al44000Sprint06 = () => {
	const sprint = 6
	return ( <div>
		<h5>Sprint 6: {getModuleDescription(sprint-1)}</h5>

		<p>Welcome to sprint 6. This sprint will see us working in our scrum teams to deliver functionality our  
		customers. After completing sprint {sprint} planning, you and your team will spend your time 
		your time working on what you have identified as the most valuable stories for your product.</p>

		<p>When we are not working on our class project, we will be focusing on a few key concepts that will help us
		understand the health of our software product and allow us to effectively integrate with common non-agile 
		project management practices like Gantt charts and Critical Path exercises.</p>

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Utilize Agile development and Software-As-A-Service (Saas) to deliver functionality for your Class Project</li>
			<li>Understand and work with Software Metrics</li>
			<li>Understand projects (vs. Agile products) and work with simple Gantt Charts and Critical Path exercises</li>
			<li>Prepare to participate in Celebration of Scholarship on Thursday, April 24</li>
		</ul>
		{list44000Sprint06(sprint)}
	</div> )
}

export const list44000Sprint06 = (sprint) => {
	const softwareMetrics = () => { return externalLink('Software Metrics', 'https://lewiseducation.blob.core.windows.net/software-engineering/software-engineering-metrics.mp4')}
	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			<li><em>Review sprint {sprint} assignments</em></li>
			<li><em>Submit Lab {sprint} - Planning</em> after completing {softwareEngineeringSprint6Link()} Requirements 0, 1, and 2 and </li>
			<li>Review {softwareMetrics()} lecture</li>
			<li>Within {oreillyPlaylistSE()} “Scaling Software Agility” read chapters 1 and 2 focussing on “Assumptions Underlying the Model”</li>

			{initialPost(sprint)}
			<li>Within {oreillyPlaylistSE()} watch “Project Management” by Jeffrey Pinto Lessons 1 through 5 focussing on:{estimated('2 hours')}</li>
			<ul style={{listStyleType:'square'}}>
					<li>Lesson 1: Why Projects?</li>
					<li>Lesson 4: Creating the Project Network</li>
					<li>Lesson 5: Duration Estimation and Critical Path</li>
			</ul>
			<li>Complete {softwareEngineeringSprint6Link()} Requirements 3 and 4 {estimated('8 hours capacity per team member')}</li>

			<li><em>Submit Discussion, Quiz, Lab, and Reflection</em></li>
		</ol>
	</div> )
}

// Certified for SP25 on April 6, 2025

